import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  accessToken: null,
  refreshToken: null,
  isAuthenticated: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setCredentials: (state, action) => {
      const { accessToken, refreshToken } = action.payload || {};
      state.accessToken = accessToken || null;
      state.refreshToken = refreshToken || null;
      state.isAuthenticated = Boolean(accessToken);
    },
    setAccessToken: (state, action) => {
      state.accessToken = action.payload || null;
      state.isAuthenticated = Boolean(action.payload);
    },
    setRefreshToken: (state, action) => {
      state.refreshToken = action.payload || null;
    },
    clearAuth: () => initialState,
  },
});

export const { setCredentials, setAccessToken, setRefreshToken, clearAuth } =
  authSlice.actions;

export default authSlice.reducer;
